<template>
    <div class="">
        <div class="flex items-baseline justify-between">
            <h2 class="hidden lg:block uppercase font-semibold text-base text-grey-dark">Series</h2>
            <add-series><i class="fa fa-pencil"></i></add-series>
        </div>

        <ul class="border list-reset h-32 overflow-y-auto text-sm bg-white shadow-inner" v-show="hasItems">
            <li v-for="(item, index) in items">
                <analyze-series :item="item" :index="index"></analyze-series>
            </li>
        </ul>

        <div class="h-32 bg-white flex items-center justify-center shadow-inner" v-show="!hasItems">
            <add-series><i class="fa fa-pencil"></i></add-series>
        </div>
    </div>
</template>

<script>
    export default {
        name: "History",

        computed: {
            hasItems() {
                return this.items.length > 0;
            },
            items() {
                return this.$store.getters.history;
            },
        }
    }
</script>
